export default __webpack_public_path__ + "static/media/arrow-back.12d8fad0.svg";